
import React from 'react';
import ActionsDrawer from './ActionsDrawer';

function ActionsDrawerContainer(props) {
    const actions = [{ name: "Download Gif", action: () => props.setIsGifSaved(true) }, { name: "Track in Calendar", action: () => { } }];
    const myItems = [{ name: "My Calendar", action: () => { } }];

    return (<ActionsDrawer {...props} actions={actions} myItems={myItems} />);
}

export default ActionsDrawerContainer;